module.exports = __webpack_public_path__ + "assets/c1f5b001ecfcf9e4bc224343e05ce8ac.mp4";